import { UPDATE_NOTIFICATION } from "../actionTypes";

const initialState = { data: [] };

export default function index(state = initialState, action) {
  switch (action.type) {
    case UPDATE_NOTIFICATION: {
      return {
        ...state,
        ...action.payload,
      };
    }

    default:
      return state;
  }
}
